/**
 * mSTEM Open Project row-action cell (PRJ-02 S-2). Renders the ℹ detail button
 * next to the existing "Tải dự án" button for a single project row.
 *
 * Class component with bindAll so per-row handlers satisfy react/jsx-no-bind
 * without inline arrow allocations — mirrors KitActionsCell (SMH-04).
 */
import bindAll from 'lodash.bindall';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './open-project-modal.css';

class ProjectActionsCell extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, ['handleDetail', 'handleLoad']);
    }
    handleDetail (e) {
        if (e && e.stopPropagation) e.stopPropagation();
        this.props.onDetail(this.props.row);
    }
    handleLoad (e) {
        if (e && e.stopPropagation) e.stopPropagation();
        this.props.onLoad(this.props.row.id);
    }
    render () {
        const {detailLabel, loadLabel, loadingLabel, isLoading} = this.props;
        return (
            <div className={styles.actionsCell}>
                <button
                    aria-label={detailLabel}
                    className={styles.iconBtn}
                    title={detailLabel}
                    type="button"
                    onClick={this.handleDetail}
                >
                    {'ℹ'}
                </button>
                <button
                    className={classNames(styles.btnPrimary, styles.btnSmall)}
                    disabled={isLoading}
                    type="button"
                    onClick={this.handleLoad}
                >
                    {isLoading ? loadingLabel : loadLabel}
                </button>
            </div>
        );
    }
}

ProjectActionsCell.propTypes = {
    detailLabel: PropTypes.string.isRequired,
    isLoading: PropTypes.bool,
    loadLabel: PropTypes.string.isRequired,
    loadingLabel: PropTypes.string.isRequired,
    onDetail: PropTypes.func.isRequired,
    onLoad: PropTypes.func.isRequired,
    row: PropTypes.shape({id: PropTypes.string.isRequired}).isRequired
};

ProjectActionsCell.defaultProps = {
    isLoading: false
};

export default ProjectActionsCell;
